import { useContext, useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";

import ConfigContext from "context/ConfigContext";
import LocationContext from "context/LocationContext";
import { getDomainCountryCode } from "redux/selectors/config";
import { getFilteredOverride } from "utils/seoMetaDataStrings";

import { DeliveryValidation } from "../DeliveryValidation";

const Hero = () => {
  const { finderLocation } = useContext(LocationContext);

  const { state, city, formattedLocation } = finderLocation;
  const location = city ? formattedLocation : state;
  const { FAQData, isLocationPage, retailType } = useContext(ConfigContext);
  const h1Override = FAQData?.data?.h1_override;

  const { query } = useRouter();
  const includesDeliveryFilter = !!query.filter?.includes("delivery");
  const includesPickupFilter = !!query.filter?.includes("pickup");
  const includesSingleFilter =
    query?.filter &&
    !Array.isArray(query.filter) &&
    ["black_owned", "open_now", "medical"].includes(query.filter);

  const tab =
    (includesDeliveryFilter && "delivery") ||
    (includesPickupFilter && "pickup") ||
    "all";

  const [showDeliveryValidation, setShowDeliveryValidation] = useState(false);

  const countryCode = useSelector(getDomainCountryCode);
  const canadaSafeWord = countryCode === "CA" ? "stores" : "dispensaries";

  const tabHeader = {
    all: "Shop all",
    delivery: "Delivery",
    pickup: "Pickup",
  };
  const headerMessage = {
    "cbd-store": `${tabHeader[tab]} CBD stores ${
      isLocationPage ? `in ${location}` : "near you"
    }`,
    clinic: `Shop all MMJ doctors ${
      isLocationPage ? `in ${location}` : "near you"
    }`,
    dispensary: includesSingleFilter
      ? `${
          isLocationPage
            ? `${location} ${getFilteredOverride(
                query.filter as string
              ).toLowerCase()}`
            : `${getFilteredOverride(query.filter as string)}`
        }`
      : tab === "all"
      ? `Find weed dispensaries near you in ${location}`
      : `${tabHeader[tab]} ${canadaSafeWord} in ${location}`,
  };

  useEffect(() => {
    setShowDeliveryValidation(includesDeliveryFilter);
  }, [query]);

  return (
    <div>
      <div className="py-md width-full">
        <h1
          id="finder-listings__header-message"
          className="heading--s font-bold"
          data-testid="header-message"
        >
          {h1Override ?? headerMessage[retailType]}
        </h1>
        {showDeliveryValidation && <DeliveryValidation />}
      </div>
    </div>
  );
};

export default Hero;
